import { useTheme } from "@mui/material";
import { SdkParameters } from "onfido-sdk-ui/types";
import { RefObject, useMemo } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { selectConfig } from "../selectors";
import { onfidoStyles } from "../style";
import { toggleCrossDeviceSteps } from "../utils";

export type TUseConfig = {
  containerRef: RefObject<Element>;
} & SdkParameters;

export const useConfig = ({
  containerRef,
  onComplete,
  onError,
}: TUseConfig) => {
  const theme = useTheme();
  const currentConfig = useSelector(selectConfig);
  const [searchParams] = useSearchParams();

  const config = useMemo(() => {
    if (
      !containerRef.current ||
      !currentConfig ||
      !currentConfig?.steps?.length
    ) {
      return undefined;
    }
    return {
      ...currentConfig,
      steps: toggleCrossDeviceSteps(currentConfig.steps, searchParams),
      customUI: onfidoStyles(theme),
      onComplete,
      onError,
    };
  }, [containerRef, currentConfig, onComplete, onError, searchParams, theme]);
  return config;
};
